export default "__VITE_ASSET__9e2635a5__"